/*
 * Shopify's built-in cookie consent banner (Customer Privacy API) is not
 * part of this theme's markup and its disclosure text isn't editable from
 * Shopify admin (Settings > Customer privacy only offers color/position).
 * This swaps the banner body text for the store's own custom wording.
 * Built with DOM methods (textContent/createElement), not innerHTML
 * string concatenation, so there's no HTML-escaping risk. If the banner
 * markup isn't found (e.g. a different structure in another region),
 * this simply does nothing and leaves Shopify's own text in place.
 */
window.theme = window.theme || {};

(function () {
  function replaceBannerText() {
    var body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');
    if (!body) return false;
    if (body.dataset.customText === 'true') return true;

    var originalParagraph = body.querySelector('p');
    if (!originalParagraph) return false;

    var p1 = document.createElement('p');
    p1.textContent = 'Denne hjemmeside bruger cookies for at sikre, at du får den bedste oplevelse.';

    body.querySelectorAll('p').forEach(function (p) { p.remove(); });
    body.appendChild(p1);
    body.dataset.customText = 'true';

    return true;
  }

  if (replaceBannerText()) return;

  var observer = new MutationObserver(function () {
    if (replaceBannerText()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
